import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterMessagesView.
 * @extends JetView
 */
export default class FilterMessagesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering messages
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id', // Input for Message ID
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Mensaje Id'),
                            labelPosition: 'top',
                            placeholder: _('Mensaje Id'),
                            invalidMessage: _('Mensaje Id is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Name', // Input for Name
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            invalidMessage: _('Nombre is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'Type', // Dropdown for Message Type
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Casino') },
                                { id: '2', value: _('Live Casino') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsActivate', // Dropdown for Activation Status
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'TypeReport', // Dropdown for Report Type
                            value: '0',
                            label: _('Tipo Reporte'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '0', value: _('Mensaje') },
                                { id: '1', value: _('Banner Invasivo') },
                                { id: '2', value: _('Popup') },
                                { id: '3', value: _('Franja') },
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Second left section with additional filters
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified', // Dropdown for Verification Status
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'Abbreviated', // Input for Abbreviated Message
                            label: _('Abreviado'),
                            labelPosition: 'top',
                            placeholder: _('Abreviado'),
                            invalidMessage: _('Abreviado is required'), // Validation message
                        },
                        { id: 'grav3', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section for the main filter layout
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 320 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        // Second upper section for additional filters
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 130 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Include left2 section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Include upper_section2
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Enviar banner invasivo'), // Button for sending invasive banner
                            type: 'form',
                            width: screen == 'small' ? 0 : 180,
                            click: () => {
                                this.app.callEvent('sendInvasiveBanner:button', [[]]); // Event call for invasive banner
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Enviar popup'), // Button for sending popup
                            type: 'form',
                            width: screen == 'small' ? 0 : 180,
                            click: () => {
                                this.app.callEvent('sendPopup:button', [[]]); // Event call for popup
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Enviar franja'), // Button for sending fringe
                            type: 'form',
                            width: screen == 'small' ? 0 : 180,
                            click: () => {
                                this.app.callEvent('sendfringe:button', [[]]); // Event call for fringe
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Añadir Mensaje'), // Button for adding message
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('messageListAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-messageListAdd',
                            click: () => {
                                this.app.callEvent('addMessage:button', [[]]); // Event call for adding message
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'), // Button for clearing inputs
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear(); // Clear the form inputs
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Consultar'), // Button for filtering messages
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('messages:filter', [filterdata]); // Event call for filtering messages
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for main filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Include upper_section
                                    accordion_section, // Include accordion_section
                                    buttons, // Include buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main configuration for the form
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Include accordion_section1
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity elements for small screens
                $$('grav2').hide();
                $$('grav3').hide();
            }
        });
    }
}

// FILE DOCUMENTED
